<template>
  <div>
    <select
      :ref="initRef"
      v-model="model"
      v-show="instance === null"
      :disabled="disabled"
    />
  </div>
</template>
<script setup>
/*

Just select tag w/ typeahead support,
model is a primitive value as defined in "keys" prop

*/

import { computed, inject, onUnmounted, ref, shallowRef, watch } from 'vue'
import Choices from 'choices.js'

const model = defineModel()
const props = defineProps({
  options: {
    type: Array,
    default: () => [],
  },
  keys: {
    type: String,
    default: 'id',
  },
  values: {
    type: [String, Function],
    default: 'name',
  },
  shouldSelect: {
    type: Function,
    default: x => Number(x),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  autoSort: {
    type: Boolean,
    default: true,
  },
})
const instance = ref(null)
const initRef = el => {
  if (!instance.value) {
    instance.value = new Choices(el, {
      allowHTML: true,
      shouldSort: props.autoSort,
      resetScrollPosition: false,
      searchEnabled: true,
      searchResultLimit: -1,
      searchFields: [props.values, 'label'],
      itemSelectText: '',
      fuseOptions: {
        shouldSort: true,
        findAllMatches: true,
        ignoreLocation: true,
        threshold: 0.4,
      },
    })
    setall()
  }
}

const formEditable = inject('form:editable', () => shallowRef(true), true)
const disabled = computed(() => formEditable.value === false || props.disabled)
onUnmounted(() => {
  instance.value.destroy()
})

watch(
  () => props.options,
  () => setall(),
  { immediate: true }
)
watch(model, setall, { immediate: true })
watch(
  () => [formEditable.value, props.disabled],
  ([a, b]) => {
    if (!instance.value) {
      return
    }

    if (!a || b) {
      instance.value.disable()
    } else {
      instance.value.enable()
    }
  },
  { immediate: true }
)

function setall() {
  if (!instance.value) {
    return
  }
  let options = props.options
  let values = props.values

  if (props.values instanceof Function) {
    values = '__label'
    options = options.map(o => {
      o[values] = props.values(o)
      return o
    })
  }
  instance.value.clearStore()
  instance.value.setChoices(options, props.keys, values, true)
  if (model.value) {
    instance.value.setChoiceByValue(props.shouldSelect(model.value))
  } else {
    instance.value.removeActiveItems()
  }
}
</script>
